var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 25,
    viewBox: "0 0 43 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15698 0H1.30814C0.585674 0 0 0.585674 0 1.30814V9.15698C0 9.87944 0.585674 10.4651 1.30814 10.4651H9.15698C9.87944 10.4651 10.4651 9.87944 10.4651 9.15698V1.30814C10.4651 0.585674 9.87944 0 9.15698 0ZM8.13954 8.72093H2.32558V2.32558H8.13954V8.72093Z",
    fill: "#25003F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4418 22.9167V2.08333C42.4418 0.932739 41.4006 0 40.1163 0C38.8319 0 37.7907 0.932739 37.7907 2.08333V22.9167C37.7907 24.0673 38.8319 25 40.1163 25C41.4006 25 42.4418 24.0673 42.4418 22.9167Z",
    fill: "#25003F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3023 22.9167V2.08333C34.3023 0.932739 33.2611 0 31.9767 0C30.6923 0 29.6511 0.932739 29.6511 2.08333V22.9167C29.6511 24.0673 30.6923 25 31.9767 25C33.2611 25 34.3023 24.0673 34.3023 22.9167Z",
    fill: "#25003F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1628 22.9167V2.08333C26.1628 0.93274 25.1216 0 23.8372 0C22.5528 0 21.5116 0.93274 21.5116 2.08333V22.9167C21.5116 24.0673 22.5528 25 23.8372 25C25.1216 25 26.1628 24.0673 26.1628 22.9167Z",
    fill: "#25003F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0196 11.2727L7.08348 19.1783L4.0988 16.0536C3.18309 15.0991 1.67336 15.0738 0.726722 15.9971C-0.219921 16.9204 -0.245003 18.4426 0.670699 19.3971L5.32891 24.2789C5.77313 24.7359 6.37973 24.9954 7.01435 25H7.04295C7.66802 24.998 8.26729 24.7485 8.71171 24.3053L18.3571 14.6907C19.0316 14.1055 19.3266 13.1902 19.1223 12.3169C18.918 11.4437 18.2483 10.7579 17.3855 10.5383C16.5227 10.3187 15.6105 10.6019 15.0196 11.2727Z",
    fill: "#25003F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.4419,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlack);
export default __webpack_public_path__ + "static/media/iconBlack.bc853aafa8d104e7e925bcf52320459c.svg";
export { ForwardRef as ReactComponent };